import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'ax-rich-text-theme',
  template: '<ng-content></ng-content>',
  styleUrls: ['./rich-text-theme.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RichTextThemeComponent {}
